export default "__VITE_ASSET__Dkc08fAS__"